/* tslint:disable */
import { Coord } from './coord';

/**
 */
export class Dashboard {
    connection?: Coord;
    study?: Coord;
    studyEquipment?: Coord;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/dashboard.ts